import API from './apiClient';

export const login = (formData) => API.post('/users/login', formData);
export const logout = () => API.post('/users/logout');
export const getProfile = () => API.get('/users/profile');
export const forgotPassword = (email) => API.post('/users/forgotpassword', { email });
export const resetPassword = (token, password) => API.put(`/users/resetpassword/${token}`, { password });
